const DITypes = {
  RpcDispatcher: Symbol('RpcDispatcher'),
  WebServiceRpcDispatcher: Symbol('WebServiceRpcDispatcher'),
  AdapterFactory: Symbol('AdapterFactory'),
};

export default DITypes;
